import React from "react";
import {useRouteMatch} from "react-router-dom";
import {Row, Col} from 'reactstrap'
import {useDispatch} from 'react-redux';
import PartnerPage from "./PartnerPage";
import PartnerDetailsForm from "../../components/forms/app/partner/PartnerDetailsForm";
import {fetchPartnerDetails} from "../../actions/partners";

let PartnerDetailsPage = () => {

    let match = useRouteMatch();

    let partnerId = match.params.id

    let dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(fetchPartnerDetails(partnerId, ['roles']))
    }, [partnerId, dispatch])

    return <PartnerPage partnerId={partnerId}>
        <Row className='fitheight'>
            <Col lg={{size: 8, offset: 2}}>
                <PartnerDetailsForm partnerId={partnerId}/>
            </Col>
        </Row>
    </PartnerPage>

}

export default PartnerDetailsPage
